import React, { HTMLProps, useMemo } from 'react'
import get from 'lodash/get'
import { GroupType, SelectType } from 'tennders-common/types/SelectType'
import useTranslation from 'next-translate/useTranslation'
import { isNil, isEmpty } from 'lodash'

type Value = string | number
type ObjectValue = { id?: Value }
type Props = Omit<HTMLProps<HTMLSelectElement>, 'onChange' | 'form' | 'defaultelement'> & {
  onSet?: (value: any) => void,
  readOnly?: boolean,
  value?: Value | ObjectValue,
  items?: SelectType[],
  groups?: GroupType[],
  defaultItem?: SelectType | boolean,
  error?: string,
  loading?: boolean,
  placeholder?: string
}

const Select = (props: Props) => {
  const {
    onSet,
    className,
    error,
    items,
    value,
    multiple,
    readOnly,
    groups,
    placeholder,
    defaultItem = { label: 'Select', value: 'false' },
    loading,
    ...rest
  } = props
  const { t } = useTranslation()

  const val = useMemo(() => ((typeof value === 'object' && value?.id) ? value.id : (typeof value === 'undefined' ? '' : value)), [value])

  return (
    <select
      multiple={multiple}
      disabled={!!readOnly}
      onChange={(e) => onSet(e.target?.value)}
      value={val}
      className={
        (className || 'form-select w-auto mr-4')
        + (error ? ' error' : '')
        + (readOnly ? ' disabled' : '')
        + (!isNil(val) && !isEmpty(val?.toString()) && val !== 'false' && val ? ' selected' : '')
      }
      {...rest}
    >
      {loading && <option>{t('common:loading')}...</option>}
      {defaultItem && <option value={get(defaultItem, 'value')}>{get(defaultItem, 'label') === 'Select' ? t('common:select') : get(defaultItem, 'label')}</option>}
      {placeholder && <option value="" disabled selected hidden>{placeholder}</option>}
      {groups && groups.map((group, key) => (
        <optgroup key={key as never} label={group.label}>
          {group.items?.map((item, key) => (
            <option
              key={key as never}
              value={item.value || item.id}
            >
              {item.label}
            </option>
          ))}
        </optgroup>
      ))}
      {items && items.map((item) => (
        <option
          key={get(item, 'id') + get(item, 'label') + get(item, 'value')}
          selected={item.value === value}
          value={typeof item.value === 'undefined' ? item.id : item.value}
        >
          {item.label}
        </option>
      ))}
    </select>
  )
}
export default React.memo(Select)
